<template>
  <BaseSelector
    class="vehicleAmountSelector"
    :title="title"
    :options="options"
    :selectValue="selectValue"
    @selectChangeHandler="selectChangeHandler"
  ></BaseSelector>
</template>

<script>
import BaseSelector from '@/components/common/select/BaseSelector'

export default {
  props: {
    selectValue: {
      type: Number,
    },
  },
  data() {
    return {
      title: '車輛數:',
      options: [
        { value: 1, description: '1' },
        { value: 2, description: '2' },
        { value: 3, description: '3' },
        { value: 4, description: '4' },
        { value: 5, description: '5' },
        { value: 6, description: '6' },
        { value: 7, description: '7' },
        { value: 8, description: '8' },
        { value: 9, description: '9' },
      ],
    }
  },
  methods: {
    selectChangeHandler(value) {
      this.$emit('selectChangeHandler', value)
    },
  },
  components: {
    BaseSelector,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/common/select/VehicleAmountSelector.vue